export default __webpack_public_path__ + "static/media/sri-lanka.c5c549ea.svg";